export const MAX_FILE_SIZE_MB = 500;
export const MINIMUM_DPI = 90;
export const DPI_WARNING = 150;
